import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { getOverrides } from '../../overrides.js';
import '../icon/icons/account.js';
import '../icon/icons/action.js';
import '../icon/icons/ad.js';
import '../icon/icons/add-car.js';
import '../icon/icons/add.js';
import '../icon/icons/additional-cost.js';
import '../icon/icons/advertiser-type.js';
import '../icon/icons/after-sales-service.js';
import '../icon/icons/air-conditioning-01.js';
import '../icon/icons/air-conditioning-02.js';
import '../icon/icons/air-conditioning-03.js';
import '../icon/icons/amenities.js';
import '../icon/icons/announcements-on-site.js';
import '../icon/icons/apple-car-android-auto.js';
import '../icon/icons/apple.js';
import '../icon/icons/archive.js';
import '../icon/icons/arrow-down.js';
import '../icon/icons/arrow-left.js';
import '../icon/icons/arrow-right.js';
import '../icon/icons/arrow-up.js';
import '../icon/icons/at.js';
import '../icon/icons/attachment.js';
import '../icon/icons/auto-repost-off.js';
import '../icon/icons/auto-repost-on.js';
import '../icon/icons/baby-pacifier.js';
import '../icon/icons/balcony-garden-terrace.js';
import '../icon/icons/bank.js';
import '../icon/icons/bathroom.js';
import '../icon/icons/bedroom.js';
import '../icon/icons/benefit-center.js';
import '../icon/icons/block-user.js';
import '../icon/icons/blueprint.js';
import '../icon/icons/boat-propulsion.js';
import '../icon/icons/boat.js';
import '../icon/icons/body-type.js';
import '../icon/icons/bold-text.js';
import '../icon/icons/bookmark-filled.js';
import '../icon/icons/bookmark.js';
import '../icon/icons/brand.js';
import '../icon/icons/bullet-list.js';
import '../icon/icons/cabrio.js';
import '../icon/icons/calculator.js';
import '../icon/icons/calendar.js';
import '../icon/icons/call.js';
import '../icon/icons/camera.js';
import '../icon/icons/car-1.js';
import '../icon/icons/car-2.js';
import '../icon/icons/car-accident.js';
import '../icon/icons/car-basic.js';
import '../icon/icons/car-financing.js';
import '../icon/icons/car-history.js';
import '../icon/icons/car-washing.js';
import '../icon/icons/car.js';
import '../icon/icons/caravan.js';
import '../icon/icons/card.js';
import '../icon/icons/chat.js';
import '../icon/icons/check-filled.js';
import '../icon/icons/check-up.js';
import '../icon/icons/check.js';
import '../icon/icons/chevron-down.js';
import '../icon/icons/chevron-left.js';
import '../icon/icons/chevron-right.js';
import '../icon/icons/chevron-up.js';
import '../icon/icons/chopper.js';
import '../icon/icons/city-car.js';
import '../icon/icons/clear-content.js';
import '../icon/icons/clear.js';
import '../icon/icons/close.js';
import '../icon/icons/coin-money.js';
import '../icon/icons/color.js';
import '../icon/icons/comfort-access.js';
import '../icon/icons/complaint-book.js';
import '../icon/icons/condition.js';
import '../icon/icons/construction-material.js';
import '../icon/icons/construction-start.js';
import '../icon/icons/contact-views.js';
import '../icon/icons/copy.js';
import '../icon/icons/coupe.js';
import '../icon/icons/credit-card.js';
import '../icon/icons/cross.js';
import '../icon/icons/cruiser.js';
import '../icon/icons/cube.js';
import '../icon/icons/cv.js';
import '../icon/icons/delivery.js';
import '../icon/icons/document.js';
import '../icon/icons/door.js';
import '../icon/icons/double-chevron-down.js';
import '../icon/icons/double-chevron-up.js';
import '../icon/icons/double-tick.js';
import '../icon/icons/download.js';
import '../icon/icons/drivetrain.js';
import '../icon/icons/early-access.js';
import '../icon/icons/edit.js';
import '../icon/icons/education.js';
import '../icon/icons/email-at.js';
import '../icon/icons/email.js';
import '../icon/icons/enduro.js';
import '../icon/icons/engine.js';
import { IconError } from '../icon/icons/error.js';
import '../icon/icons/estate.js';
import '../icon/icons/external-link.js';
import '../icon/icons/eye-hidden.js';
import '../icon/icons/eye-not.js';
import '../icon/icons/eye.js';
import '../icon/icons/facebook.js';
import '../icon/icons/fast-repair.js';
import '../icon/icons/fence.js';
import '../icon/icons/file-attachment.js';
import '../icon/icons/filter.js';
import '../icon/icons/finish-condition.js';
import '../icon/icons/flag.js';
import '../icon/icons/floor.js';
import '../icon/icons/form-of-the-property.js';
import '../icon/icons/fuel.js';
import '../icon/icons/fullscreen-view.js';
import '../icon/icons/glass-roof.js';
import '../icon/icons/globe.js';
import '../icon/icons/goods.js';
import '../icon/icons/grid-view.js';
import '../icon/icons/grid.js';
import '../icon/icons/hatchback.js';
import '../icon/icons/headlights.js';
import '../icon/icons/heart-default.js';
import '../icon/icons/heart-filled.js';
import '../icon/icons/heart-on-hand.js';
import '../icon/icons/heart-search.js';
import '../icon/icons/heating.js';
import '../icon/icons/height-of-rooms.js';
import '../icon/icons/helpdesk.js';
import '../icon/icons/home-default.js';
import '../icon/icons/home-filled.js';
import '../icon/icons/home.js';
import '../icon/icons/hud.js';
import '../icon/icons/id-card.js';
import '../icon/icons/info.js';
import '../icon/icons/insert-link.js';
import '../icon/icons/instagram.js';
import '../icon/icons/interior.js';
import '../icon/icons/investment-status.js';
import '../icon/icons/italic-text.js';
import '../icon/icons/jobs.js';
import '../icon/icons/kiosk.js';
import '../icon/icons/land-area.js';
import '../icon/icons/license-plate.js';
import '../icon/icons/lighting.js';
import '../icon/icons/like.js';
import '../icon/icons/list-item-default.js';
import '../icon/icons/list-item-filled.js';
import '../icon/icons/list-view.js';
import '../icon/icons/list.js';
import '../icon/icons/location.js';
import '../icon/icons/lock.js';
import '../icon/icons/login-to-continue.js';
import '../icon/icons/logout.js';
import '../icon/icons/lorry.js';
import '../icon/icons/lory.js';
import '../icon/icons/machinery.js';
import '../icon/icons/make-model.js';
import '../icon/icons/map-view.js';
import '../icon/icons/market.js';
import '../icon/icons/material.js';
import '../icon/icons/meal-1.js';
import '../icon/icons/meal-2.js';
import '../icon/icons/menu.js';
import '../icon/icons/message-default.js';
import '../icon/icons/message-filled.js';
import '../icon/icons/message.js';
import '../icon/icons/milage.js';
import '../icon/icons/millage.js';
import '../icon/icons/minus.js';
import '../icon/icons/moped.js';
import '../icon/icons/more-info.js';
import '../icon/icons/more.js';
import '../icon/icons/motociclos-nacionais.js';
import '../icon/icons/motorbike.js';
import '../icon/icons/motorcycle-125.js';
import '../icon/icons/mpv.js';
import '../icon/icons/n-people-in-the-room.js';
import '../icon/icons/n-rooms.js';
import '../icon/icons/naked.js';
import '../icon/icons/no-camera.js';
import '../icon/icons/non-smoker.js';
import '../icon/icons/notification-default.js';
import '../icon/icons/notification-filled.js';
import '../icon/icons/notification.js';
import '../icon/icons/one-owner.js';
import '../icon/icons/open-photo-gallery.js';
import '../icon/icons/package-selected.js';
import '../icon/icons/parking-assistance.js';
import '../icon/icons/parking-space.js';
import '../icon/icons/parts-1.js';
import '../icon/icons/parts-2.js';
import '../icon/icons/parts-3.js';
import '../icon/icons/parts-4.js';
import '../icon/icons/parts-cog.js';
import '../icon/icons/parts-disc-brake.js';
import '../icon/icons/parts-steering-wheel.js';
import '../icon/icons/parts-timing-belt.js';
import '../icon/icons/party-popper.js';
import '../icon/icons/passport.js';
import '../icon/icons/pause.js';
import '../icon/icons/people.js';
import '../icon/icons/percent.js';
import '../icon/icons/picture.js';
import '../icon/icons/ping-pong.js';
import '../icon/icons/play.js';
import '../icon/icons/plot-type.js';
import '../icon/icons/plutus.js';
import '../icon/icons/postpaid.js';
import '../icon/icons/power-on.js';
import '../icon/icons/power.js';
import '../icon/icons/premium.js';
import '../icon/icons/price.js';
import '../icon/icons/print.js';
import '../icon/icons/private-seller.js';
import '../icon/icons/professional-seller.js';
import '../icon/icons/proforma.js';
import '../icon/icons/promote.js';
import '../icon/icons/properties-in-investment.js';
import '../icon/icons/purpose.js';
import '../icon/icons/qr-code.js';
import '../icon/icons/quad.js';
import '../icon/icons/quality-mark-filled.js';
import '../icon/icons/quality-mark.js';
import '../icon/icons/question-mark.js';
import '../icon/icons/read-messages.js';
import '../icon/icons/real-estate-agency.js';
import '../icon/icons/real-estate-agent.js';
import '../icon/icons/real-estate-consultant.js';
import '../icon/icons/real-estate-developer.js';
import '../icon/icons/real-estate-investors.js';
import '../icon/icons/real-estate-managers.js';
import '../icon/icons/real-estate-private-seller.js';
import '../icon/icons/refresh.js';
import '../icon/icons/remote-support.js';
import '../icon/icons/remote-work.js';
import '../icon/icons/rent.js';
import '../icon/icons/rental.js';
import '../icon/icons/repair.js';
import '../icon/icons/reset-size.js';
import '../icon/icons/resize-to-width.js';
import '../icon/icons/resize.js';
import '../icon/icons/restore.js';
import '../icon/icons/road-mileage.js';
import '../icon/icons/scooter-above-125.js';
import '../icon/icons/scooter.js';
import '../icon/icons/screen-desktop.js';
import '../icon/icons/screen-mobile.js';
import '../icon/icons/scroller-1.js';
import '../icon/icons/scroller-2.js';
import '../icon/icons/search-history.js';
import '../icon/icons/search.js';
import '../icon/icons/seat.js';
import '../icon/icons/security.js';
import '../icon/icons/sedan.js';
import '../icon/icons/send.js';
import '../icon/icons/share.js';
import '../icon/icons/sheet-metal-repairs.js';
import '../icon/icons/size-1.js';
import '../icon/icons/size.js';
import '../icon/icons/small-city-car.js';
import '../icon/icons/sms-finance.js';
import '../icon/icons/sms.js';
import '../icon/icons/social-facebook.js';
import '../icon/icons/social-instagram.js';
import '../icon/icons/social-linkedin.js';
import '../icon/icons/social-tiktok.js';
import '../icon/icons/social-twitter.js';
import '../icon/icons/social-whatsapp.js';
import '../icon/icons/social-x-aka-twitter.js';
import '../icon/icons/social-youtube.js';
import '../icon/icons/sort-by.js';
import '../icon/icons/sound-system.js';
import '../icon/icons/sport-tourism.js';
import '../icon/icons/sport.js';
import '../icon/icons/stack-view.js';
import '../icon/icons/stack.js';
import '../icon/icons/star-default.js';
import '../icon/icons/star-filled.js';
import '../icon/icons/star-half.js';
import '../icon/icons/star.js';
import '../icon/icons/stats.js';
import '../icon/icons/stethoscope.js';
import '../icon/icons/style.js';
import '../icon/icons/styling.js';
import '../icon/icons/suitcase.js';
import '../icon/icons/sun-and-sea.js';
import '../icon/icons/surface.js';
import '../icon/icons/suspension.js';
import '../icon/icons/suv-crossover-tt.js';
import '../icon/icons/target.js';
import '../icon/icons/technical-review.js';
import '../icon/icons/telephone.js';
import '../icon/icons/tempomat.js';
import '../icon/icons/test-drive.js';
import '../icon/icons/thumbs-down.js';
import '../icon/icons/thumbs-up.js';
import '../icon/icons/tick-double.js';
import '../icon/icons/tick-one.js';
import '../icon/icons/tick.js';
import '../icon/icons/time.js';
import '../icon/icons/tire-storage.js';
import '../icon/icons/tire.js';
import '../icon/icons/token.js';
import '../icon/icons/tooth.js';
import '../icon/icons/touring.js';
import '../icon/icons/towing.js';
import '../icon/icons/tractor.js';
import '../icon/icons/trailler.js';
import '../icon/icons/transfer.js';
import '../icon/icons/translation-bubble.js';
import '../icon/icons/transmission.js';
import '../icon/icons/trash.js';
import '../icon/icons/travel-assistance.js';
import '../icon/icons/tricycle.js';
import '../icon/icons/truck.js';
import '../icon/icons/trunk-access.js';
import '../icon/icons/twitter.js';
import '../icon/icons/type-of-building.js';
import '../icon/icons/unarchive.js';
import '../icon/icons/unordered-list.js';
import '../icon/icons/unread-messages.js';
import '../icon/icons/upload.js';
import '../icon/icons/user-default.js';
import '../icon/icons/user-filled.js';
import '../icon/icons/utilitarian.js';
import '../icon/icons/video.js';
import '../icon/icons/virtual-cockpit.js';
import '../icon/icons/voice.js';
import '../icon/icons/wallet.js';
import '../icon/icons/warning.js';
import '../icon/icons/weight.js';
import '../icon/icons/year-of-construction.js';
import '../icon/icons/youtube.js';
import { Wrapper, StyledImage } from './styled-components.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Image = (_a) => {
  var _b = _a, { onError, onLoad, loading = "lazy", $style, placeholder, width, height, overrides } = _b, props = __objRest(_b, ["onError", "onLoad", "loading", "$style", "placeholder", "width", "height", "overrides"]);
  const [loaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  const resolvedStyle = useResolvedStyle($style);
  const onAfterLoadHandler = (event) => {
    setIsLoaded(true);
    onLoad == null ? void 0 : onLoad(event);
  };
  const onErrorHandler = (event) => {
    setIsLoaded(false);
    setError(true);
    onError == null ? void 0 : onError(event);
  };
  const [Root, rootOverrideProps] = getOverrides(overrides == null ? void 0 : overrides.Root, Wrapper);
  const [ImageComponent, imageOverrideProps] = getOverrides(overrides == null ? void 0 : overrides.Image, StyledImage);
  return jsxs(Root, __spreadProps(__spreadValues({}, rootOverrideProps), { "$style": mergeStyles(__spreadValues({
    height: height ? `${height}px` : "auto",
    width: width ? `${width}px` : "auto"
  }, rootOverrideProps.$style), resolvedStyle), children: [jsx(ImageComponent, __spreadValues(__spreadValues({ onError: onErrorHandler, onLoad: onAfterLoadHandler, loading, "$loaded": loaded, width: loaded ? width : "0", height: loaded ? height : "0" }, props), imageOverrideProps)), !loaded && (error ? jsx(IconError, { size: 96 }) : placeholder)] }));
};

export { Image };
